import React from "react";
import { ShoppingBag, Calendar } from "lucide-react";
import { getAddonRateDisplay, formatAddonDaysSummary } from "../../utils/addonPricingUtils";

const AddonsBreakdown = ({ addons, currency = "KES" }) => {
  if (!addons || addons.length === 0) return null;

  const totalAddonsPrice = addons.reduce((sum, addon) => sum + (addon.totalPrice || (addon.unitPrice || 0) * (addon.quantity || 1)), 0);

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 mb-2">
        <ShoppingBag className="w-4 h-4 text-indigo-600" />
        <h3 className="text-sm font-semibold text-gray-900">Booked Add-ons</h3>
      </div>

      <div className="p-3 bg-gray-50 rounded-xl border border-gray-200 space-y-2">
        {addons.map((addon, index) => {
          const unitTotal = addon.totalPrice || (addon.unitPrice || 0) * (addon.quantity || 1);
          const daysSummary = formatAddonDaysSummary(addon);
          return (
            <div
              key={index}
              className="flex justify-between items-start text-sm py-1 border-b border-gray-100 last:border-0 border-dashed"
            >
              <div className="flex-1">
                <div className="font-medium text-gray-900 flex items-center gap-1.5 flex-wrap">
                  <span>{addon.name || "Add-on"}</span>
                  <span className="text-xs text-gray-500 font-normal">x{addon.quantity || 1}</span>
                  {daysSummary && (
                    <span className="text-[9px] font-semibold px-1.5 py-0.2 rounded bg-emerald-50 text-emerald-700 border border-emerald-100 flex items-center gap-0.5">
                      <Calendar className="w-2.5 h-2.5" />
                      {daysSummary}
                    </span>
                  )}
                </div>
                <div className="text-[10px] text-gray-500 uppercase tracking-tight">
                  {getAddonRateDisplay(addon, currency)}
                </div>
              </div>
              <div className="text-right ml-4">
                <div className="font-semibold text-gray-900">
                  {currency} {unitTotal.toLocaleString()}
                </div>
              </div>
            </div>
          );
        })}

        <div className="pt-2 mt-1 border-t border-gray-200 flex justify-between items-center bg-white -mx-3 -mb-3 p-3 rounded-b-xl">
          <span className="text-xs font-bold text-indigo-900 uppercase">Add-ons Total</span>
          <span className="text-sm font-bold text-indigo-600">
            {currency} {totalAddonsPrice.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AddonsBreakdown;
